import { FlexIndexGranularityEnum, StageEnum } from '@/enums/benchmarking/FlexIndexEnums.ts';
import { IFlexIndexGroupOptions } from '@/interfaces/benchmarks/flexIndex/IFlexIndexGroup.ts';
import { IDashboardCommonSettings } from '@/interfaces/powerMarkets/dashboard/IDashboard.ts';

import dayjs from 'dayjs';

export const MAX_FLEX_INDICES_TO_COMPARE = 4;
export const DEFAULT_FLEX_ICON_COLOUR = 'var(--lcpBlue)';
export const DEFAULT_FLEX_ICON_ID = 'calculations';
export const DEFAULT_FLEX_SCENARIO_ALLOWED_STAGES : Array<StageEnum> = [StageEnum.DayAhead, StageEnum.Intraday];

export const DEFAULT_FLEX_INDEX_OVERRIDES: IDashboardCommonSettings = {
    sharedTooltipAcrossModules: false,
    useYAxisNormalisation: true,
    sharedLegendToggling: true,
};

export const DEFAULT_FLEX_INDEX_GROUP_OPTIONS: IFlexIndexGroupOptions = {
    granularity: FlexIndexGranularityEnum.Day,
    selectedDateModel: {
        dateType: 'fixed',
        dateRange: {
            from: dayjs().subtract(2, 'year').startOf('year').toISOString(),
            to: dayjs().startOf('year').toISOString(),
        },
    },
};
